import {BaseModel} from "../base/base.model";
import {ProvincesModel} from "../provinces/provinces.model";
export class ClientLocationsModel extends BaseModel{
    id?: number;
    address_1?: string;
    address_2?: string;
    city?  : string;
    province_id?: number;
    province?: ProvincesModel;
    postal_code?: string;
}


// WEBPACK FOOTER //
// ./src/app/models/client-locations/client-locations.model.ts